<template>

        <div class="modal-mask" v-on:keyup.esc="$emit('close')">
            <div class="modal-wrapper">
                <div class="modal-container card">
                    <div class="modal-body">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <slot>

                        </slot>

                    </div>
                    <!-- <button class="btn btn-secondary"  @click="$emit('close')">
                        Закрити
                    </button> -->
                </div>

            </div>

        </div>



</template>

<script>

    export default {
        name: "modal",
        data() {
            return {

                editPr: false,
                partyData: [],
            }
                },
        mounted() {



        },
        props: [],
        methods: {

        },
        computed: {

            }

        // props: ['content']
    }
    //<modal v-if="showModal" @close="showModal = false" :send-data="sendData" ></modal>
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }



    * {
        box-sizing: border-box;
    }

    .modal-mask {
        position: fixed;
        z-index: 9999999999;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .3s ease;
    }

    .modal-container {
        width: 75%;
        margin: 10px auto 0;
        padding: 10px 10px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        height: 80vh;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        overflow-y: auto;
    }

    .text-right {
        text-align: right;
    }

    .form-label {
        display: block;
        margin-bottom: 1em;
    }

    .form-label > .form-control {
        margin-top: 0.5em;
    }

    .form-control {
        display: block;
        width: 100%;
        padding: 0.5em 1em;
        line-height: 1.5;
        border: 1px solid #ddd;
    }
    .modal-header{
        margin-bottom: 20px;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    .close{
        position: absolute;
        right: 30px;
        top: 30px
    }
</style>